import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ExamFormContainerService {


  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  private dataExamSubject = new BehaviorSubject({});
  dataExam = this.dataExamSubject.asObservable();
  constructor(private http: HttpClient) { }

  updateDataExam(data: any){
    this.dataExamSubject.next(data);
  }

  loadClinico(request: any): Observable<any> {
    request.modelId = this.currentUser.modelId;
    request.userId = this.currentUser.userId;
    request.prestadorCod = this.currentUser.prestadorCod;
    return this.http.post<any>(this.buildUrlApi('exams/carga/clinico'), request);
  }

  private buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

}
